'use client';

import {
  faArrowUp,
  faMicrophone,
  faSpinner,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

import { useProjectResponseModeContext } from '@/shared-survey';
import { ProjectType } from '@/survey-graphql';

import { ProjectResponseSendComponentProps } from './project-response-renderer.type';
import { useProjectResponseSend } from './project-response-send.hooks';

export default function ProjectResponseSelectSendButtonDesktop({
  disabled,
  isSubmitting,
  renderMobileView,
  type,
  isUserVoiceEnabled,
}: ProjectResponseSendComponentProps) {
  const tChat = useTranslations('Chat');
  const tUserTest = useTranslations('UserTest');

  const { handleToggle } = useProjectResponseSend(type);
  const { projectType } = useProjectResponseModeContext();
  const isUsability = projectType === ProjectType.UsabilityTesting;

  return (
    <div
      className='hidden flex-1 items-center gap-2 sm:flex'
      data-state={renderMobileView ? 'mobile' : 'desktop'}
      data-test='select-send-button-desktop'
    >
      {isUserVoiceEnabled && (
        <button
          onClick={handleToggle}
          type='button'
          className='inline-flex items-center justify-center gap-2 rounded-full bg-gray-100 px-3 py-2 text-black transition-colors hover:bg-gray-200'
          data-test='select-voice-button'
        >
          <FontAwesomeIcon icon={faMicrophone} className='size-4 text-black' />
          <span className='[font-family:var(--brand-font)] text-xs font-medium text-black'>
            {tChat('voice')}
          </span>
        </button>
      )}
      <button
        disabled={disabled}
        data-state={renderMobileView ? 'mobile' : 'desktop'}
        data-usability={isUsability}
        className='group w-full flex-1 items-center justify-center transition-all disabled:opacity-20 data-[usability=false]:h-8 data-[usability=false]:gap-2 data-[usability=false]:rounded-full data-[usability=false]:bg-(--brand-primary) data-[usability=false]:px-3 data-[usability=false]:py-2 data-[usability=true]:flex data-[usability=true]:gap-3 data-[usability=true]:rounded-2xl data-[usability=true]:bg-gray-900 data-[usability=true]:px-6 data-[usability=true]:py-4 data-[usability=true]:hover:enabled:bg-gray-800'
        data-test='select-send-button'
      >
        {isSubmitting ? (
          <FontAwesomeIcon
            icon={faSpinner}
            className='relative size-5 animate-spin group-data-[usability=false]:text-(--brand-primary-contrast) group-data-[usability=true]:text-white'
          />
        ) : (
          <div className='flex flex-nowrap items-center justify-center text-center group-data-[usability=false]:gap-2 group-data-[usability=true]:gap-3'>
            <FontAwesomeIcon
              icon={faArrowUp}
              className='relative h-3 w-2.5 group-data-[usability=false]:text-(--brand-primary-contrast) group-data-[usability=true]:text-white'
            />
            <div className='group-data-[usability=false]:h-4'>
              <span className='block text-center [font-family:var(--brand-font)] text-xs font-medium group-data-[usability=false]:text-(--brand-primary-contrast) group-data-[usability=true]:text-white'>
                {isUsability ? tUserTest('doneContinue') : tChat('send')}
              </span>
            </div>
          </div>
        )}
      </button>
    </div>
  );
}
